export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/freelance_impact_perseus/freelance-economy-2025.5357bdc.pdf";